import { Component, OnInit, Injector } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-cadastro',
    templateUrl: './cadastro.component.html',
    styleUrls: ['./cadastro.component.scss'],
    standalone: false
})

export class CadastroComponent implements OnInit {

  router: Router;

  showDatePicker = false;

  errorMessage: string = '';
  caracterMaiusculo: boolean = false;
  caracterMinusculo: boolean = false;
  caracterEspecial: boolean = false;
  caracterNumerio: boolean = false;
  tamanhoSenha: boolean = false;
  liberaEnvio: boolean = false;

  public fase:string = 'check';

  public formCheck:any = {};
  public formCadastro:any = {};

  constructor(
    injector: Injector,
    public settings: SettingsService,
    private http: HttpClient
  ) {
    this.router = injector.get(Router);
  }

  ngOnInit() {

    this.formCheck = {
      cpf: ''
    };

    this.formCadastro = {
      cpf: '',
      nome: '',
      sobrenome: '',
      sexo: '',
      nascimento: '',
      dia: '',
      mes: '',
      ano: '',
      celular: '',
      email: '',
      senha: '',
      confirmar: '',
      regulamento: false
    };

  }

  checkCPF() {

    try {

      //console.log('Verificando CPF...');

      if (this.formCheck.cpf == '' || this.formCheck.cpf.replace(/[.-]/g, '').length != 11) {

        this.formCheck.cpf = '';
        return this.errorMessage = "CPF inválido! Verifique o número digitado.";

      }

      let config = {
        headers: {
          "x-token": this.settings.configUso.X_TOKEN_API
        },
        params: {
          "cpf": this.formCheck.cpf
        }
      };

      let url = this.settings.configUso.urlApiPadrao + 'proxy/hotsite/v1/usuario/consulta';

      this.http.get(url, config)
        .subscribe(data =>
        {

          //console.log('>>>>> Resultado busca CPF: ' + JSON.stringify(data['result']));

          if (data['status'] == 200) {

            if (data['result'].status == false) {

              return this.errorMessage = 'Usuário inativo na base de pré cadastro.';

            } else if (data['result'].optin == true) {

              return this.errorMessage = 'Usuário já cadastrado! Faça seu login para ter acesso a plataforma.';

            } else if (data['result'].status == true && data['result'].optin == false) {

              this.formCadastro.cpf = data['result'].cpf;
              this.fase = 'cadastro';

            } else {

              return this.errorMessage = 'Erro inesperado. Tente novamente mais tarde.';

            }

          }
          else
          {
            //console.log('>>>>> Checa CPF error: ' + data['message']);
            return this.errorMessage = data['message'];
          }

        });

    } catch (err) {

      //console.log('>>>>> Catch: Erro ao buscar CPF.');
      return this.errorMessage = 'Erro inesperado. Tente novamente mais tarde.';

    }

  };

  confirmar() {

    //console.log('>>>>>>>>> Validando cadastro...');
    //console.log('>>>>> formCadastro: ' + JSON.stringify(this.formCadastro));

    if (this.formCadastro.cpf == '' || this.formCadastro.cpf.replace(/[.-]/g, '').length != 11) {
      return this.errorMessage = 'Preencha corretamente o campo CPF.';
    }

    if (this.formCadastro.nome == '') {
      return this.errorMessage = 'Preencha o campo Nome.';
    }

    if (this.formCadastro.sobrenome == '') {
      return this.errorMessage = 'Preencha o campo Sobrenome.';
    }

    if (this.formCadastro.sexo == '') {
      return this.errorMessage = 'Preencha o campo Sexo.';
    }

    if (this.formCadastro.nascimento == '') {
      return this.errorMessage = 'Preencha corretamente sua data de nascimento.';
    }

    if (this.formCadastro.celular == '' || this.formCadastro.celular.length != 11) {
      return this.errorMessage = 'Preencha corretamente campo Celular.';
    }

    if (this.formCadastro.email == '') {
      return this.errorMessage = 'Preencha corretamente o campo E-mail.';
    }

    if (this.formCadastro.senha == '' || this.formCadastro.senha != this.formCadastro.confirmar) {

      return this.errorMessage = 'Verifique sua senha e confirmação.';

    } else {

      if (this.formCadastro.senha.length < 4) {

        return this.errorMessage = 'Sua senha precisa ter pelo menos 8 caracteres.';
      }
    }

    this.formCadastro.cpfTratado = this.formCadastro.cpf.replace(/\D+/g, "");
    this.formCadastro.celularTratado = this.formCadastro.celular.replace(/\D+/g, "");
    this.formCadastro.nomeTratado = this.formCadastro.nome.toUpperCase() + " " + this.formCadastro.sobrenome.toUpperCase();
    this.formCadastro.emailTratado = this.formCadastro.email.toLowerCase();
    //this.formCadastro.nascimento = this.formCadastro.ano + '-' + this.formCadastro.mes + '-' + this.formCadastro.dia;

    //console.log('>>>>> formCadastro tratado: ' + JSON.stringify(this.formCadastro));

    //this.msgErro = '';
    this.fase = 'confirma';

  };

  gravarPrimeiroAcesso() {

    try {

      //console.log('>>>>>>>>>> Preparando gravar cadastro...');
      //console.log('>>>>>>>>>> formCadastro: ' + JSON.stringify(this.formCadastro));

      let config = {
        headers: {
          "x-token": this.settings.configUso.X_TOKEN_API
        }
      };

      let url = this.settings.configUso.urlApiPadrao + 'proxy/hotsite/v1/usuario/primeiroacesso';

      this.http.post(url, this.formCadastro, config)
        .subscribe(data =>
        {

          //console.log('>>>>>>>>>> Retorno grava ativacao: ' + JSON.stringify(data));

          if (data['status'] == 200)
          {
            //console.log('>>>>> Cadastro gravado com sucesso!');
            this.fase = 'sucesso';

          }
          else
          {
            const message = data['message'];
            return this.errorMessage = message;
          }

        });

    } catch (err) {
      const message = 'Erro ao gravar ativação.';
      return this.errorMessage = message;
    }

  };

  voltarCadastro() {

    this.fase = 'cadastro';

  };

  goLogin() {

    this.router.navigate(['/login']);

  };

  verificaSenha(senha) {

    console.log(senha)

    const letrasMaiusculas = /[A-Z]/;
    const letrasMinusculas = /[a-z]/;
    const numeros = /[0-9]/;
    const caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

    if(senha.length >=8) {
      this.tamanhoSenha = true;
    } else {
      this.tamanhoSenha = false;
    }

    if(letrasMaiusculas.test(senha)) {
      this.caracterMaiusculo = true;
    } else {
      this.caracterMaiusculo = false;
    }

    if(letrasMinusculas.test(senha)) {
      this.caracterMinusculo = true;
    } else {
      this.caracterMinusculo = false;
    }

    if(numeros.test(senha)) {
      this.caracterNumerio = true;
    } else {
      this.caracterNumerio = false;
    }

    if(caracteresEspeciais.test(senha)) {
      this.caracterEspecial = true;
    } else {
      this.caracterEspecial = false;
    }

  }

  confirmaSenha(senhaConfirmacao) {
    // console.log(senha, this.formCadastro.senha)
    if (this.formCadastro.senha == '' || this.formCadastro.senha !== senhaConfirmacao) {
      this.errorMessage = 'Verifique sua senha e confirmação.';
      this.liberaEnvio = false;
    } else {
      this.errorMessage = '';
      this.liberaEnvio = true;
    }
  }

}
